var map = {
	"./auspost.jpg": 1450,
	"./cese.jpg": 589,
	"./hayu.jpg": 4638,
	"./intelematics.jpg": 5469,
	"./mable.jpg": 7256,
	"./melbourneuni.jpg": 4640,
	"./myer.jpg": 3206,
	"./others.jpg": 8228,
	"./web-apps.jpg": 8066,
	"./wilde.jpg": 7888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1321;